function calculateExperience() {
  const startDate = new Date(2022, 6, 14); // 14 July 2022
  const today = new Date();

  const diffTime = today - startDate; // difference in milliseconds
  const diffDays = diffTime / (1000 * 60 * 60 * 24); // convert to days
  const yearsDecimal = (diffDays / 365).toFixed(1) + " years"; // convert to years with 1 decimal

  return yearsDecimal;
}

console.log(calculateExperience());


export const Bio = {
  name: "Devendra Patel",
  roles: ["Full Stack Developer", "Java Developer", "Programmer", "Problem Solver"],
  description:
    `I am a Java Developer with over ${calculateExperience()} of experience in building and maintaining web applications using technologies like Java, Spring Boot, and REST APIs. I enjoy solving problems, learning new skills, and working in collaborative environments. With a strong focus on writing clean, efficient code and delivering high-quality results, I am always ready to take on new challenges and contribute to the success of any team or project.`,
  github: "https://github.com/devendra1707",
  resume:
    "https://drive.google.com/file/d/1bIceR6MCZGgxoqtYTLUe20m3EY1f45Pc/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/devendra1707/",
  twitter: "https://twitter.com/devendra1707",
  insta: "https://instagram.com/devendra17071?igshid=OGU0MmVlOWVjOQ==",
  facebook:
    "https://www.facebook.com/profile.php?id=100059280595209&mibextid=ZbWKwL",
  email: "devendra6715@gmail.com",
  mobile: "+91 911 877 1922",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Liferay DXP",
        image:
          "https://media.trustradius.com/product-logos/k2/oa/612TV5WCJ19M.PNG",
      },
      {
        name: "Liferay",
        image: "https://avatars.githubusercontent.com/u/131436?s=200&v=4",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Liferay Commecre",
        image:
          "https://pbs.twimg.com/profile_images/1141815571811454976/JTODv7Tt_400x400.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image: "https://www.vectorlogo.zone/logos/java/java-icon.svg",
      },
      {
        name: "Spring Boot",
        image:
          "https://pbs.twimg.com/profile_images/1235868806079057921/fTL08u_H_400x400.png",
      },
      {
        name: "MySQL",
        image:
          "https://global-uploads.webflow.com/6203daf47137054c031fa0e6/63d66b74cca00b70f7fe0127_mysql-logo.png",
      },
      {
        name: "Spring MVC",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwsq-7f5BWyog4cdeT1sQaYLVzhJ0o37Up8TjHvVU08WUgfyyMMRMHTVwJ5XReSjyhZa0&usqp=CAU",
      },
      {
        name: "DIGIT",
        image:
          "https://raw.githubusercontent.com/devendra1707/devendra/main/public/digit.png",
      },
      {
        name: "UPYOG",
        image:
          "https://raw.githubusercontent.com/devendra1707/devendra/main/public/upyog.png",
      },
      {
        name: "Spring Cloud",
        image:
          "https://user-images.githubusercontent.com/92505396/284248050-b0c266c2-3b26-4c7d-a6fc-4d6a8cbb5565.png",
      },
      {
        name: "Spring Security",
        image:
          "https://www.javacodegeeks.com/wp-content/uploads/2014/07/spring-security-project.png",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Microservices",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwsq-7f5BWyog4cdeT1sQaYLVzhJ0o37Up8TjHvVU08WUgfyyMMRMHTVwJ5XReSjyhZa0&usqp=CAU",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image: "https://www.vectorlogo.zone/logos/java/java-icon.svg",
      },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Eclipse",
        image:
          "https://static.macupdate.com/products/11662/l/eclipse-ide-logo.webp?v=1617819161",
      },

      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://private-user-images.githubusercontent.com/92505396/311691874-d0cf2d71-ecad-493b-851c-5c8bf9ce7c08.jpg?jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJnaXRodWIuY29tIiwiYXVkIjoicmF3LmdpdGh1YnVzZXJjb250ZW50LmNvbSIsImtleSI6ImtleTUiLCJleHAiOjE3MTAxNTgxMjUsIm5iZiI6MTcxMDE1NzgyNSwicGF0aCI6Ii85MjUwNTM5Ni8zMTE2OTE4NzQtZDBjZjJkNzEtZWNhZC00OTNiLTg1MWMtNWM4YmY5Y2U3YzA4LmpwZz9YLUFtei1BbGdvcml0aG09QVdTNC1ITUFDLVNIQTI1NiZYLUFtei1DcmVkZW50aWFsPUFLSUFWQ09EWUxTQTUzUFFLNFpBJTJGMjAyNDAzMTElMkZ1cy1lYXN0LTElMkZzMyUyRmF3czRfcmVxdWVzdCZYLUFtei1EYXRlPTIwMjQwMzExVDExNTAyNVomWC1BbXotRXhwaXJlcz0zMDAmWC1BbXotU2lnbmF0dXJlPTRmNjVkMWE4YWJlNDRiYTk3ZDgwMjI0MmU0ZGEwZTgzYTEzMzE2ODVkYTM0MWE0MTkxYzViOWIyY2M5YzgzYTEmWC1BbXotU2lnbmVkSGVhZGVycz1ob3N0JmFjdG9yX2lkPTAma2V5X2lkPTAmcmVwb19pZD0wIn0.WN3zq60I1FXB4r31g29CGcJ8n583QpoIpeWyyz5yzsg",
      },
      {
        name: "Gradle",
        image: "https://www.finsmes.com/wp-content/uploads/2021/11/gradle.jpg",
      },
      {
        name: "AWS",
        image:
          "https://user-images.githubusercontent.com/92505396/284244873-0adaaa28-a384-4ab4-b68e-e4504a3334b3.png",
      },
      {
        name: "Docker",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTU9Wrr9RulsgmyA9Whgu9eUJj6uj7FQ-ecrA&usqp=CAU",
      },
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Maven",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIBojINW-cIO4uDQ_KbJ7yKLOOer4pB3yebA&usqp=CAU",
      },
      {
        name: "Dev Studio",
        image:
          "https://images.g2crowd.com/uploads/product/image/large_detail/large_detail_08606723e790dc015fb746503a9ef9da/eclipse.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 1,
    img: "https://sparrowsoftech.com/sspl/assets/img/sspl.png",
    role: "Java Developer",
    company: "Sparrow Softech Private Limited",
    date: "Feb 2026 - Present",
    desc: "Experienced and results-oriented Software Engineer with a strong foundation in Java development, specializing in the design, implementation, and deployment of robust applications. Proficient in Spring Boot and Hibernate frameworks, adept at building scalable microservices and web applications. Skilled in database management with a focus on optimizing performance. Experienced in deploying applications using CI/CD pipelines and well-versed in DevOps practices. A problem solver with a track record of analyzing complex issues and implementing effective solutions. Excellent collaboration and communication skills demonstrated through successful teamwork and stakeholder engagement. Holds a B.Tech in Computer Science from VBSPU Jaunpur, with relevant certifications in Java and Spring Boot. Check out my GitHub portfolio https://github.com/devendra1707 for a showcase of projects and code samples.",
    skills: [
      "Leadership",
      "Web Application Development",
      "Java",
      "Spring Boot",
      "RestFul Web API",
      "XML",
      "Json",
      "Microservices",
      "Thymeleaf",
      "MySQl",
      "React",
      "Digit",
      "UPYOG",
      "Angular",
      "Html",
      "Css",
      "JavScript",
    ],
  },
  {
    id: 1,
    img: "https://raw.githubusercontent.com/devendra1707/devendra/main/public/tattvalogo.jpeg",
    role: "Java Developer",
    company: "Tattva Foundation Nirala Nagar Lucknow",
    date: "Sep 2025 - Feb 2026",
    desc: "Experienced and results-oriented Software Engineer with a strong foundation in Java development, specializing in the design, implementation, and deployment of robust applications. Proficient in Spring Boot and Hibernate frameworks, adept at building scalable microservices and web applications. Skilled in database management with a focus on optimizing performance. Experienced in deploying applications using CI/CD pipelines and well-versed in DevOps practices. A problem solver with a track record of analyzing complex issues and implementing effective solutions. Excellent collaboration and communication skills demonstrated through successful teamwork and stakeholder engagement. Holds a B.Tech in Computer Science from VBSPU Jaunpur, with relevant certifications in Java and Spring Boot. Check out my GitHub portfolio https://github.com/devendra1707 for a showcase of projects and code samples.",
    skills: [
      "Leadership",
      "Web Application Development",
      "Java",
      "Spring Boot",
      "RestFul Web API",
      "XML",
      "Json",
      "Microservices",
      "Thymeleaf",
      "MySQl",
      "React",
      "Digit",
      "UPYOG",
      "Angular",
      "Html",
      "Css",
      "JavScript",
    ],
  },
  {
    id: 2,
    img: "https://user-images.githubusercontent.com/92505396/283944576-7a22880d-b30d-4691-9b32-ae03de42a751.png",
    role: "Software Engineer",
    company: "Armantec Systems Private Limited Noida Uttar Pradesh",
    date: "Jul 2022 - AUG 2025",
    desc: "Experienced and results-oriented Software Engineer with a strong foundation in Java development, specializing in the design, implementation, and deployment of robust applications. Proficient in Spring Boot and Hibernate frameworks, adept at building scalable microservices and web applications. Skilled in database management with a focus on optimizing performance. Experienced in deploying applications using CI/CD pipelines and well-versed in DevOps practices. A problem solver with a track record of analyzing complex issues and implementing effective solutions. Excellent collaboration and communication skills demonstrated through successful teamwork and stakeholder engagement. Holds a B.Tech in Computer Science from VBSPU Jaunpur, with relevant certifications in Java and Spring Boot. Check out my GitHub portfolio https://github.com/devendra1707 for a showcase of projects and code samples.",
    skills: [
      "Leadership",
      "Web Application Development",
      "Java",
      "Spring Boot",
      "RestFul Web API",
      "XML",
      "Json",
      "Microservices",
      "Thymeleaf",
      "MySQl",
      "React",
      ,
      "Angular",
      "Html",
      "Css",
      "JavScript",
    ],
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpe7n8J1BYd5onQUupwOrflGhxDKCYpEy5jOs-W5kZQkfAEfM2sYwhTrfBfT2lXEGeSMY&usqp=CAU",
    role: "Full Stack Java Development",
    company: "Naresh I Technologies Hyderabad Telangana",
    date: "Oct 2021 - March 2022",
    desc: "As an Full Stack Java Development Training Naresh I Technologies Hyderabad Telangana from October 2021 - March 2022, I gained valuable hands- on experience in application development. This training helped me enhance my skills in Java development and give me an opportunity to work in a collaborative team environment.",
    skills: [
      "Core Java",
      "Advance Java",
      "Spring",
      "Spring Boot",
      "Spring Security",
      "Microservices",
      "MySQL",
      "HTML",
      "CSS",
      "Java Script",
      "Bootstrap",
      "Firebase",
      "Git",
      "GitHub",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/e/e2/Purvanchallogo.png",
    school: "Veer Bahadur Singh Purvanchal University Jaunpur U.P.",
    date: "Aug 2017 - Aug 2021",
    grade: "65.83%",
    desc: "I completed Bachelor's degree (B.Tech) in Computer Science & Engineering at Uma Nath Singh Institute of Engineering & Technology, Jaunpur U.P.",
    degree: "Bachelor of Technology - BTech, Computer Science & Engineering",
  },
  {
    id: 1,
    img: "https://seeklogo.com/images/U/uttar-pradesh-government-logo-1FA161CB94-seeklogo.com.png",
    school: "Janta Inter College Barsathi Jaunpur",
    date: "Jul 2015 - Apr 2017",
    grade: "72.20%",
    desc: "I completed my class 12 Intermediate education at Janta Inter College, Barsathi Jaunpur, where I studied Science with Mathematics.",
    degree: "UP Board(XII), Science with Mathematics",
  },
  {
    id: 2,
    img: "https://seeklogo.com/images/U/uttar-pradesh-government-logo-1FA161CB94-seeklogo.com.png",
    school: "Janta Inter College Barsathi Jaunpur",
    date: "Jul 2013 - Apr 2015",
    grade: "74.33%",
    desc: "I completed my class 10 high school education at Janta Inter College , Barsathi Jaunpur, where I studied Science with Mathematics.",
    degree: "UP Board(X), Science with Mathematics",
  },
];

export const projects = [
  {
    id: 0,
    title: "DHIMS",
    // date: "Jun 2023 - Jul 2023",
    description:
      "Delhi health system can be informed of the number of available beds, medicines and vacant ventilators across the territory's hospitals. The system, which also features a doctor consultation booking mechanism for patients, can help reduce long queues at hospitals.",
    image:
      "https://user-images.githubusercontent.com/92505396/283994396-c4c55c91-57d8-44c3-ab2b-02e639c8bf61.png",
    tags: [
      "Docker",
      "AWS",
      "Spring Boot",
      "Hibernate",
      "Java",
      "MySql",
      "RestFull Web API",
      "CI/CD",
      "React Js",
      "Redux",
    ],
    category: "web app",
    github: "",
    webapp: "#",
  },
  {
    id: 1,
    title: "CPWD (Central Public Work Department)",
    // date: "Apr 2023 - May 2023",
    description:
      "CPWD is a government agency that manages public works projects in India, Find out the latest news, events, projects, and services of CPWD. CPWD is responsible for planning, designing, building and maintaining public works projects in India. Collaborated with cross-functional teams to design and deploy secure and compliant solutions aligned with government regulations",
    image:
      "https://user-images.githubusercontent.com/92505396/283993447-8dc89bcc-3095-4ee6-b72b-4ed6a2ac7eec.png",
    tags: [
      "Docker",
      "AWS",
      "Spring Boot",
      "Hibernate",
      "Java",
      "MySql",
      "RestFull Web API",
      "CI/CD",
      "HTML",
      "CSS",
      "Java Script",
      "Thymeleaf",
    ],
    category: "web app",
    github: "",
    webapp: "#",
  },
  {
    id: 15,
    title: "We Connect",
    // date: "Oct 2022 - Present",
    description:
      'Designed and developed the " We Connect " Project,The Employee Management System is a multifaceted Java-based application designed to serve as a comprehensive tool for efficient workforce management. This integrated platform seamlessly connects and streamlines various critical aspects of employee engagement, including the meticulous tracking of attendance records, facilitation of task assignments, maintenance of a detailed holiday list, and effective management of medical leave requests. Furthermore, the system provides centralized oversight for timesheet tracking, expense reporting, and leave applications, contributing to a more organized and transparent employee management process. By integrating these functionalities, the application not only enhances operational efficiency but also fosters a culture of accountability and adherence to company policies, ensuring a holistic and structured approach to workforce administration.',
    image:
      "https://user-images.githubusercontent.com/92505396/283999676-b58e4f32-0679-4f3a-a3c6-3e45a4d34601.png",
    tags: [
      "React Js",
      "MySql",
      "Node Js",
      "Express Js",
      "Redux",
      "Spring Boot",
    ],
    category: "web app",
    github: "https://github.com/devendra1707/ECom-React",
    webapp: "#",
  },
  {
    id: 2,
    title: "E-Commerce",
    date: "Oct 2022 - Present",
    description:
      "Designed and developed E-Commerce Project is a comprehensive online marketplace developed using a technology stack centered around Java, HTML, CSS, and JavaScript. The backend is powered by Java, employing the Spring Boot framework to handle server-side logic, manage user authentication, and facilitate seamless communication with the database. The frontend utilizes HTML for structuring web pages, CSS for styling, and JavaScript for dynamic, interactive elements, providing users with a visually appealing and responsive shopping experience. The project incorporates features such as user registration, secure authentication, a dynamic product catalog with search and filter functionalities, a shopping cart system, and a streamlined checkout process. Payment integration is achieved through popular gateways, ensuring secure online transactions. The platform supports multiple vendors, each with their own storefront and inventory management capabilities. With a focus on user experience, security, and scalability, the E-Commerce Project aims to provide a robust solution for online retail, meeting the demands of both customers and merchants.",
    image:
      "https://user-images.githubusercontent.com/92505396/283994399-f617e03f-68dd-4fec-8af3-b5b00e9a3a07.png",
    tags: [
      "React Js",
      "MySql",
      "Spring Boot",
      "Hibernate",
      "Redux",
      "RestFul Web API",
    ],
    category: "web app",
    github: "https://github.com/devendra1707/E-Commerce",
    webapp: "https://devendra1707.github.io/shopping/",
  },
  {
    id: 3,
    title: "(SCM) Smart Contact Manager",
    date: "Jan 2023 - Mar 2023",
    description:
      "The primary objective of the Smart Connect Manager project is to serve as a centralized and efficient platform for managing contact-related information, encompassing mobile numbers and email addresses. Built on the robust foundation of Spring Boot, REST APIs, Thymeleaf, and MySQL, the application offers a seamless and user-friendly interface for users to add, organize, and maintain contact details. The project aims to enhance connectivity and streamline information management by providing a comprehensive solution to store, update, and retrieve contact-related data. With a focus on simplicity, scalability, and performance, the Smart Connect Manager project empowers users to efficiently manage and access their contact information in a secure and organized manner.",
    image:
      "https://user-images.githubusercontent.com/92505396/283993460-5b49b1e4-6742-4f7c-91ef-313a06819310.png",
    tags: [
      "Spring Boot",
      "Thymeleaf",
      "MySQL",
      "Hibernate",
      "HTML",
      "Css",
      "JavaScript",
    ],
    category: "web app",
    github: "https://github.com/devendra1707/Smart-Contact-manager",
    webapp: "#",
  },
  {
    id: 6,
    title: "Live Cricket Score - 2023",
    date: "Jul 2021",
    description:
      "The Live Cricket Score - 2023 project is a dynamic web application developed using a powerful stack that includes Spring Boot, MySQL, Thymeleaf, HTML, CSS, JavaScript, and Hibernate. This comprehensive solution ensures real-time updates of cricket scores for the year 2023. Leveraging Spring Boot for its robust backend framework, the application utilizes Hibernate to interact seamlessly with the MySQL database, ensuring efficient data storage and retrieval. Thymeleaf templates facilitate the server-side rendering of HTML, while CSS and JavaScript enhance the user interface for a visually appealing and interactive experience. The project employs a RESTful architecture for smooth communication between the frontend and backend, allowing users to access live cricket scores in a responsive and dynamic environment. This solution provides an optimal balance of performance, scalability, and user engagement, offering cricket enthusiasts a cutting-edge platform to stay updated on live matches throughout the year 2023.",
    image:
      "https://user-images.githubusercontent.com/92505396/283993455-bb7e958b-56b6-40df-a15e-d2282db50e52.png",
    tags: [
      "React Js",
      "Spring Boot",
      "Java",
      "MySQL",
      "Hibernate",
      "RestFul Web API",
    ],
    category: "web app",
    github: "https://github.com/devendra1707/LiveCrickScore2023Back",
    webapp: "#",
    // member: [
    //   {
    //     name: "Devendra Patel",
    //     img: "https://user-images.githubusercontent.com/92505396/283994984-102937f6-0d3a-4d20-be32-b02f3c58a12b.jpeg",
    //     linkedin: "https://www.linkedin.com/in/devendra1707",
    //     github: "https://github.com/devendra1707/CrickScore2023Front",
    //   },
    //   {
    //     name: "Devendra Patel",
    //     img: "https://user-images.githubusercontent.com/92505396/283994984-102937f6-0d3a-4d20-be32-b02f3c58a12b.jpeg",
    //     linkedin: "https://www.linkedin.com/in/devendra1707",
    //     github: "https://github.com/devendra1707/LiveCrickScore2023Back",
    //   },
    // ],
  },

  {
    id: 4,
    title: "Blogging Application",
    date: "Dec 2021 - Apr 2022",
    description:
      "The Blogging Application is a modern and feature-rich web platform developed with a sophisticated technology stack, combining Spring Boot, MySQL, React.js, HTML, CSS, and JavaScript. This robust solution caters to bloggers and readers alike, offering seamless content creation, storage, and retrieval. Leveraging the Spring Boot framework for a robust backend, the application uses MySQL for efficient data management and persistence. The frontend is built with React.js, ensuring a dynamic and responsive user interface. HTML and CSS contribute to the platform's structure and styling, while JavaScript enhances interactivity. The application supports user authentication, enabling bloggers to create and manage personalized accounts, and incorporates a rich text editor for composing engaging posts. With a RESTful API architecture, the application ensures smooth communication between the frontend and backend, facilitating real-time updates. This Blogging Application strives to provide an optimal blend of user experience, performance, and scalability, making it an ideal choice for both bloggers and readers seeking an intuitive and visually appealing platform for sharing and consuming content.",
    image:
      "https://user-images.githubusercontent.com/92505396/285389069-603ddc96-ff47-404f-9509-6c0242eefffa.jpg",
    tags: [
      "Spring Boot",
      "MySQL",
      "Hibernate",
      "RestFul Web API",
      "React",
      "Axois",
    ],
    category: "web app",
    github: "https://github.com/devendra1707/Blog-React",
    webapp: "#",
  },
  {
    id: 5,
    title: "Exam Server Management System",
    date: "Jun 2023 - Jul 2023",
    description:
      "The Exam Server Management System is a comprehensive web application developed using Angular for the frontend, leveraging JavaScript for dynamic interactivity, and interfacing with a RESTful API powered by a robust Spring Boot backend. Data is efficiently managed and stored in a MySQL database using Hibernate for seamless integration. This system is hosted on the AWS cloud infrastructure, ensuring scalability, reliability, and optimal performance. The Angular frontend provides an intuitive and responsive user interface, allowing administrators, instructors, and students to manage exams, grades, and related information seamlessly. The Spring Boot backend handles the logic for user authentication, data processing, and communication with the database, while AWS services contribute to secure and efficient hosting. With this technological synergy, the Exam Server Management System offers a streamlined and user-friendly solution for managing exams, fostering an organized and efficient environment for academic institutions and students alike.",
    image:
      "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
    tags: [
      "Angular",
      "JavaScript",
      "RestFul API",
      "Spring Boot",
      "MySql",
      "Hibernate",
      "AWS",
    ],
    category: "web app",
    github: "https://github.com/devendra1707/examserver_angular1",
    webapp: "#",
  },

  {
    id: 7,
    title: "Movie Booking Application",
    date: "Jun 2021",
    description:
      " The Movie Booking Application is a dynamic and user-friendly web platform developed with Angular, providing an immersive experience for movie enthusiasts. The frontend, built with Angular, offers a responsive and interactive interface, enabling users to seamlessly browse movies, view showtimes, and book tickets. Leveraging Angular's powerful capabilities, the application ensures a smooth and dynamic user experience. The frontend communicates with a backend server through RESTful APIs, allowing for efficient data retrieval and updating. The backend, implemented using a technology stack such as Spring Boot, handles business logic, authentication, and interacts with a database (e.g., MySQL) through Hibernate for data storage and retrieval. This comprehensive solution allows users to register, browse movies, view detailed information, select showtimes, and securely book tickets. The Movie Booking Application aims to enhance the cinema-going experience by combining a visually appealing and intuitive frontend with a robust and scalable backend, providing moviegoers with a seamless and enjoyable booking process.",
    image:
      "https://user-images.githubusercontent.com/92505396/284256195-f8df6368-9ad5-4e89-8ec2-8db556fd7c89.png",
    tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    category: "web app",
    github: "https://github.com/devendra1707/movie_booking_angular14",
    webapp: "#",
  },
  {
    id: 8,
    title: "Admin Dashboard",
    date: "Jun 2021",
    description:
      "The Admin Dashboard built with Angular is a powerful and intuitive web-based management tool designed for efficient administration and oversight of various aspects of a system or application. Angular's robust frontend framework facilitates the creation of a responsive and dynamic user interface, allowing administrators to access, monitor, and manage critical information seamlessly. The dashboard is organized with modular components, presenting key data, analytics, and controls in an easily digestible format. Leveraging Angular's capabilities, the dashboard offers real-time updates, interactive charts, and customizable widgets, providing administrators with a comprehensive overview of system performance, user activities, and other relevant metrics. The frontend communicates with a backend server, often implemented using technologies like Node.js or Spring Boot, through RESTful APIs for secure and efficient data retrieval and manipulation. The Admin Dashboard serves as a centralized control hub, streamlining administrative tasks, facilitating quick decision-making, and enhancing the overall efficiency of system management.",
    image:
      "https://user-images.githubusercontent.com/92505396/283998329-7842c7c2-9315-49a2-a0a2-1f122dc80f01.png",
    tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    category: "web app",
    github: "https://github.com/devendra1707/admindashboardinangular15",
    webapp: "#",
  },
  {
    id: 9,
    title: "SIP Calculator",
    date: "Jun 2021",
    description:
      "The SIP (Systematic Investment Plan) Calculator is a web-based financial tool developed with a technology stack that includes Spring Boot, Hibernate, MySQL, and Thymeleaf. Utilizing Spring Boot for its backend framework, the application efficiently manages business logic, data processing, and interacts with a MySQL database through Hibernate for secure and organized data storage. The frontend, powered by Thymeleaf, provides a dynamic and user-friendly interface, enabling users to input investment parameters, calculate potential returns, and visualize the results. The SIP Calculator leverages the capabilities of Spring Boot's RESTful API architecture to facilitate seamless communication between the frontend and backend. Users can input investment details, view calculated returns based on SIP strategies, and receive insightful reports. This financial tool, with its robust technology stack, aims to simplify investment planning, allowing users to make informed decisions about their Systematic Investment Plans.",
    image:
      "https://user-images.githubusercontent.com/92505396/283999209-ede48caa-374d-4f4b-ae91-b70fbd86e9fc.png",
    tags: ["React Js", "Local Storage", "AWS Auth", "Thymeleaf"],
    category: "web app",
    github: "https://github.com/devendra1707/SIPCalculator",
    webapp: "#",
  },
  {
    id: 10,
    title: "Cafe Management System",
    date: "Jun 2021",
    description:
      "The Cafe Management System is a comprehensive web application developed with a technology stack comprising Spring Boot, Angular, MySQL, Hibernate, HTML, CSS, and JavaScript. Leveraging Spring Boot for the backend, the system efficiently manages cafe operations, processing business logic and ensuring seamless communication with the MySQL database through Hibernate for data storage and retrieval. The frontend, built with Angular, offers an interactive and user-friendly interface, allowing cafe staff to manage orders, inventory, and customer interactions efficiently. The HTML, CSS, and JavaScript components enhance the user experience with a visually appealing and responsive design. The system supports functionalities such as order processing, menu management, inventory tracking, and customer relationship management. This Cafe Management System, with its robust technology stack, aims to streamline cafe operations, enhance customer service, and provide cafe owners with a comprehensive tool for managing their business effectively.",
    image:
      "https://user-images.githubusercontent.com/92505396/283996486-aaefcafd-63d9-45bc-b940-b5b4481be758.png",
    tags: [
      "React Js",
      "API",
      "Axios",
      "Node JS",
      "Spring Boot",
      "MySQL",
      "Hibernate",
    ],
    category: "web app",
    github: "https://github.com/devendra1707/CafeManagementSystemSpringBoot",
    webapp: "#",
  },
  {
    id: 11,
    title: "Bus Reservation System",
    date: "Dec 2020 - Jan 2021",
    description:
      "The Bus Reservation System is a comprehensive web-based application designed to facilitate seamless booking and management of bus services. Built on a technology stack that may include Spring Boot, Angular, MySQL, Hibernate, HTML, CSS, and JavaScript, the system offers a user-friendly interface for travelers to browse available routes, select seats, and make reservations. The backend, powered by Spring Boot and utilizing Hibernate, manages the business logic and interacts with a MySQL database for efficient storage and retrieval of reservation and route information. The Angular frontend ensures a dynamic and responsive user experience, allowing passengers to view schedules, select seat preferences, and make secure online payments. The system may include features such as user authentication, real-time seat availability updates, and booking confirmations. Overall, the Bus Reservation System aims to streamline the booking process, improve user experience, and provide bus operators with a robust tool for managing schedules, reservations, and customer information.",
    image:
      "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
    tags: ["Java", "Spring Boot", "Firebase", "React"],
    category: "web app",
    github: "https://github.com/devendra1707/BusReservationSystem",
    webapp: "#",
  },
  {
    id: 12,
    title: "CRYPTO DASHBOARD",
    date: "Jan 2021",
    description:
      "The Crypto Dashboard is a dynamic and responsive web application developed using React, designed to provide users with real-time insights and analysis of cryptocurrency data. Leveraging React's component-based architecture, the dashboard offers an interactive and visually appealing interface for tracking cryptocurrency prices, market trends, and portfolio performance. The frontend fetches and displays data from various cryptocurrency APIs, presenting it in easy-to-understand charts, tables, and graphs. React's efficient state management ensures seamless updates and responsiveness to user interactions. The Crypto Dashboard may include features such as price alerts, historical data analysis, and user authentication for personalized portfolios. With its modern and user-friendly design, the Crypto Dashboard serves as a comprehensive tool for cryptocurrency enthusiasts, traders, and investors to stay informed and make informed decisions in the ever-changing world of digital assets.",
    image:
      "https://user-images.githubusercontent.com/92505396/283998678-9afd4820-43f8-46a6-8f98-670d8de1d89b.png",
    tags: ["Spring Boot", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "web app",
    github: "https://github.com/devendra1707/CRYPTO-DASHBOARD",
    webapp: "#",
  },
  {
    id: 13,
    title: "Student Management Syatem",
    date: "Jan 2021",
    description:
      "The Student Management System is a robust web application developed with a technology stack that includes Spring Boot, Thymeleaf, MySQL, and Hibernate. Utilizing Spring Boot for the backend, the system efficiently manages student-related data, handles business logic, and interacts seamlessly with a MySQL database using Hibernate for secure and organized data storage. The frontend, powered by Thymeleaf, provides a dynamic and user-friendly interface for administrators, educators, and students to manage academic information, course enrollments, and grades. The system supports functionalities such as student registration, course management, and grade tracking. With its modern and responsive design, the Student Management System aims to simplify administrative tasks, enhance communication between educators and students, and provide a centralized platform for efficient management of academic records.",
    image:
      "https://user-images.githubusercontent.com/92505396/283997884-698e4c14-b7a7-4af5-bc05-0a73337855f1.png",
    tags: [
      "Spring Boot",
      "MySQL",
      "Thymeleaf",
      "Hibernate",
      "HTML",
      "Css",
      "JavaScript",
    ],
    category: "web app",
    github:
      "https://github.com/devendra1707/Student-Management-Project/tree/main/Student-Management-System",
    webapp: "#",
  },
  {
    id: 14,
    title: "Online Training System",
    date: "Jan 2021",
    description:
      "The Online Training System static website is a visually engaging and informative platform designed with HTML, CSS, and JavaScript to provide users with comprehensive details about various online training courses. The HTML structure forms the backbone of the website, organizing content logically, while CSS is employed for styling, ensuring a visually appealing and cohesive design. JavaScript is utilized for interactive elements, enhancing user engagement and providing dynamic features. The website includes sections for course descriptions, instructor details, registration information, and testimonials, all presented in a user-friendly layout. The responsive design ensures accessibility across different devices. The Online Training System static website serves as a gateway for potential learners to explore available courses, understand the training approach, and make informed decisions about their educational journey in a straightforward and visually appealing manner.",
    image:
      "https://user-images.githubusercontent.com/92505396/283997866-43420d00-2775-4a47-9bf2-cd20c123f4bc.png",
    tags: ["HTML", "Css", "JavaScript"],
    category: "web app",
    github: "https://github.com/devendra1707/NIT-Project",
    webapp: "#",
  },
  {
    id: 15,
    title: "Covid Tracking System",
    date: "Jan 2021",
    description:
      "The Covid Tracking System is a web application developed with a technology stack that includes Spring Boot, Thymeleaf, and Hibernate. Utilizing Spring Boot for the backend, the system manages the tracking of COVID-19 cases, seamlessly handling business logic and interacting with a database through Hibernate for secure and organized data storage. Thymeleaf is employed for the frontend, providing a dynamic and user-friendly interface for users to access real-time COVID-19 data, view statistics, and receive updates. The system may include features such as regional case tracking, graphical representations of data, and informational sections. With its modern design and responsive layout, the Covid Tracking System aims to keep users informed about the ongoing pandemic, providing a centralized and accessible platform for monitoring and understanding COVID-19 trends and statistics.",
    image:
      "https://user-images.githubusercontent.com/92505396/284250972-ab09af4a-c9c6-442e-804e-61b9430c9c5d.png",
    tags: ["Spring Boot", "MySQL", "Hibernate", "Thymeleaf", "React"],
    category: "web app",
    github: "https://github.com/devendra1707/CovidTrackingApplication",
    webapp: "#",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
